module.exports = __webpack_public_path__ + "img/02.f83cc3df.png";